<script>
    import{ _ } from "svelte-i18n";

    export let image;
</script>

<div style="display: flex; justify-content: center; align-items: center">
    <img
        src={image}
        style="max-width:100%; object-fit: contain; height: 100%;
    max-height:100%; margin-top: 8px;"
    alt={$_("audio_image_alt")}
    />
</div>

<style>
    div {
        height: 272px;
    }

    @media (min-width: 1440px) {
        div {
            height: 334px;
        }
    }
</style>
